import { render, staticRenderFns } from "./MaterielPriceListdetail.vue?vue&type=template&id=41a95592&scoped=true"
import script from "./MaterielPriceListdetail.vue?vue&type=script&lang=js"
export * from "./MaterielPriceListdetail.vue?vue&type=script&lang=js"
import style0 from "./MaterielPriceListdetail.vue?vue&type=style&index=0&id=41a95592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a95592",
  null
  
)

export default component.exports